// Agent-side additions to the shared curriculum palette. Everything else on this page reuses the
// admin page's buttonStyles so the two views read as one feature.

import { calendarEntrySx } from "../../CurriculumManagementAdmin/components/buttonStyles";

// Green matches the earned-badge chip, so an attended session reads as an achievement at a glance.
export const attendedEntrySx = {
	...calendarEntrySx,
	backgroundColor: "#ECFFF7",
	color: "#0F7A53",
	border: "1px solid #B7EBD5",
	borderLeft: "3px solid #0F7A53",
	"&:hover, &:focus-visible": {
		backgroundColor: "#D8F7EA",
		outline: "none",
	},
};

// Neutral counterpart to badgeChipSx, for a training the agent has not sat in yet.
export const notAttendedChipSx = {
	backgroundColor: "#F2F5F9 !important",
	color: "#4A6A8A !important",
	border: "1px solid #DDE5EE",
	fontWeight: 600,
	fontSize: "0.7rem",
	height: 22,
};
